module.exports = __webpack_public_path__ + "assets/img/ic-intro-bag.70456c09.png";